<template>
    <div class="outer-wrapper">
       <div class="container">
            <div class="text-center">
			<h5 class="header-1"><b></b></h5>
            <img src="img/medco_banner.png"/>
			<div class="dear-cust-div1" style="text-align:center;">
                <h3 style="margin:0;">Rs 500/- Cashback in Doodhvale Wallet!</h3>
			</div>
            <div class="dear-cust-div1" style="text-align:justify;">
                <p> Dear Customer, team Doodhvale glad to share with you that we get associated with <b>Medcobox (an online pharmacy delivery app at lowest rate ever)</b> in current COVID 19 era and bringing a lot of benefits to our prestigious customers. Like, you can purchase original and genuine medicines at regular <b>discount up to 80% </b> with extra flat <b>25% discount</b> (up to Rs 200/-) on your first order on MedcoBox using your Doodhvale registered mobile number. As curtsey, we also give you <b>10% (up to Rs 500/-) CASHBACK </b>in your Doodhvale wallet on your first order delivered by MedcoBox team. </p>
				<p> So, why wait longer! Download MedcoBox app today or visit <span style="color: #74C7FC;cursor: pointer;" v-on:click.prevent="openUrl"> www.medcobox.com </span>and order now to get these discounts on all medicines in addition of cash back in your Doodhvale wallet. </p>
				<p>	Use Promotional Code: <b>DOODHVALE </b>and get you’re top up discount of flat 25% on regular MedcoBox discounts on your first order. </p>
				<p>	Click link to download MedcoBox app on your first order <span style="color: #74C7FC;cursor: pointer;" v-on:click.prevent="openAppUrl"> https://www.medcobox.com/app-link </span></p>
				<p>	<b>Note: Download MedcoBox app using your Doodhvale registered mobile number to get all above benefits.</b> </p>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
   methods: {
    openUrl: function () {   
	  window.open("https://www.medcobox.com", "_blank");    
	},
	openAppUrl: function () {   
	  window.open("https://t.doodhvale.in/#/a/medcoAppLink", "_blank");    
	}
  }
}
</script>
<style>
    .membership p, .bottomParaDiv p {text-align:justify;}
</style>